<template>
    <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <router-link to="/" class="navbar-item">
                Orthodontic index
            </router-link>
            <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" @click="showNav = !showNav" :class="{ 'is-active': showNav }">>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
        </div>

        <div class="navbar-menu" :class="{ 'is-active': showNav }">
            <div class="navbar-start">
                <router-link class="navbar-item" to="/pre-icon">
                    Pre ICON
                </router-link>
                <router-link class="navbar-item" to="/post-icon">
                    Post ICON
                </router-link>
                <router-link class="navbar-item" to="/iotn">
                    IOTN
                </router-link>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
  name: 'navigation',
  data: function() {
      return {
          showNav: false
      }
  }
}
</script>